module.exports = __webpack_public_path__ + "img/logo.e1d53c17.png";